import { createAction } from 'redux-actions';
import actionType from 'redux/modules/notification/notificationActionType';

const updateNotification = (event, success) => {
  return async (dispatch, getState) => {
    dispatch(createAction(actionType.NOTIFICATION_EDITOR_UPDATE)({ event, success }));
    setTimeout(() => {
      dispatch(createAction(actionType.NOTIFICATION_EDITOR_HIDE)('hidding'));
    }, 3000);
  };
};

export {
  updateNotification
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/notification/notificationAction.js
 **/